import React from 'react';
import ReactDOM from 'react-dom';

// import { mountTargetBasic, unmountTarget } from '../../components/mountableBasic';

// a lighter version for when all you need is just the component
export const mountTargetBasic = (component, target, props = {}) => {
  // https://medium.com/@TranscendMikey/react-gotcha-dynamically-rendering-components-with-jsx-b53fc07f63ca
  /* eslint-disable react/jsx-pascal-case */
  const $component = component;

  ReactDOM.render(<$component {...props} />, target);
};

export const unmountTarget = (target) => {
  // This will trigger componentWillUnmount()
  ReactDOM.unmountComponentAtNode(target);
};
